<template>
    <div class="col-12 p-4 row justify-content-center">
        <h2 class="title col-12">
            {{ t("gifs.new-ex") }}
        </h2>
        <div
            class="col-12 card card-outline card-primary p-2"
            :class="{ 'col-md-10': forms == 1, 'col-md-12': forms > 1 }"
            v-if="!loading"
        >
            <div
                class="row p-3 m-0 justify-content-center gap-3"
                v-if="forms <= 0"
            >
                <div class="col-auto p-1">
                    <button class="btn btn-primary" @click="bisetType">
                        {{ t("new.biset") }}
                    </button>
                </div>
                <div class="col-auto p-1">
                    <button
                        class="btn btn-success"
                        @click="() => (this.forms = 1)"
                    >
                        {{ t("new.normal") }}
                    </button>
                </div>
                <div class="col-auto p-1">
                    <button class="btn btn-success" @click="profile">
                        {{ t("student-profile.title") }}
                    </button>
                </div>
            </div>

            <form
                @submit.prevent="submit"
                v-else
                class="row flex-wrap col-12"
                ref="abc"
            >
                <input
                    type="file"
                    class="d-none"
                    name="imagefile"
                    ref="file"
                    @change="addImage"
                />
                <div class="col-12 p-2">
                    <label>{{
                        t(
                            isProfile
                                ? "student-profile.name"
                                : "exercices.title",
                        )
                    }}</label>
                    <div
                        class="row p-o m-0 justify-content-between align-items-center"
                    >
                        <InputColor
                            v-model:pure-color="treino.colors.title[0]"
                            style="width: 2rem; height: 2rem"
                        />

                        <input
                            type="text"
                            v-model="treino.title"
                            class="form-control"
                            :placeholder="
                                t(
                                    isProfile
                                        ? 'student-profile.name'
                                        : 'gifs.title',
                                )
                            "
                            style="
                                flex: 1 !important;
                                text-align: center;
                                text-transform: uppercase;
                            "
                            :style="{
                                backgroundColor: treino.colors.title[0],
                                color: treino.colors.title[1],
                            }"
                            required
                        />

                        <InputColor
                            v-model:pure-color="treino.colors.title[1]"
                            style="width: 2rem; height: 2rem"
                        />
                    </div>
                </div>
                <div
                    class="col-12 row m-0 p-0 gap-1"
                    :class="{ 'col-md-12': forms == 1, 'col-md-6': forms > 1 }"
                    v-for="i in forms"
                    :key="i"
                >
                    <hr class="hr col-12" v-if="forms > 1" />
                    <h5 class="h5 text-bold col-12" v-if="forms > 1">
                        {{ t("new.ex" + i) }}
                    </h5>
                    <div class="col-12 col-md-7">
                        <!-- duration	charge	series	group	 -->
                        <div class="px-2 col-12 pt-0">
                            <div
                                class="row p-0 m-0 py-1 justify-content-between align-items-center"
                            >
                                <InputColor
                                    v-model:pure-color="
                                        fillVar(i).colors.duration[0]
                                    "
                                    style="width: 2rem; height: 2rem"
                                />

                                <input
                                    :id="'h_duration' + i"
                                    maxlength="20"
                                    class="edit col-10 border-none text-bold"
                                    :placeholder="
                                        t(
                                            isProfile
                                                ? 'student-profile.duration'
                                                : 'gifs.duration',
                                        )
                                    "
                                    v-model="fillVar(i)['h_duration']"
                                    style="
                                        flex: 1 !important;
                                        text-align: center;
                                    "
                                    :style="{
                                        backgroundColor:
                                            fillVar(i).colors.duration[0],
                                        color: fillVar(i).colors.duration[1],
                                    }"
                                />
                                <label
                                    :for="'h_duration' + i"
                                    role="button"
                                    class="fa fa-edit"
                                ></label>

                                <InputColor
                                    v-model:pure-color="
                                        fillVar(i).colors.duration[1]
                                    "
                                    style="width: 2rem; height: 2rem"
                                />
                            </div>

                            <input
                                type="text"
                                v-model="fillVar(i)['duration']"
                                class="form-control"
                                required
                                :placeholder="
                                    t(
                                        isProfile
                                            ? 'student-profile.duration'
                                            : 'gifs.duration',
                                    )
                                "
                            />
                        </div>
                        <div class="px-2 col-12 pt-0">
                            <div
                                class="row p-0 m-0 py-1 justify-content-between align-items-center"
                            >
                                <InputColor
                                    v-model:pure-color="
                                        fillVar(i).colors.charge[0]
                                    "
                                    style="width: 2rem; height: 2rem"
                                />

                                <input
                                    :id="'h_charge' + i"
                                    :placeholder="
                                        t(
                                            isProfile
                                                ? 'student-profile.charge'
                                                : 'gifs.charge',
                                        )
                                    "
                                    maxlength="20"
                                    class="edit col-10 border-none text-bold"
                                    v-model="fillVar(i)['h_charge']"
                                    style="
                                        flex: 1 !important;
                                        text-align: center;
                                    "
                                    :style="{
                                        backgroundColor:
                                            fillVar(i).colors.charge[0],
                                        color: fillVar(i).colors.charge[1],
                                    }"
                                />
                                <label
                                    :for="'h_charge' + 1"
                                    role="button"
                                    class="fa fa-edit"
                                ></label>

                                <InputColor
                                    v-model:pure-color="
                                        fillVar(i).colors.charge[1]
                                    "
                                    style="width: 2rem; height: 2rem"
                                />
                            </div>
                            <input
                                type="text"
                                v-model="fillVar(i)['charge']"
                                class="form-control"
                                required
                                :placeholder="
                                    t(
                                        isProfile
                                            ? 'student-profile.charge'
                                            : 'gifs.charge',
                                    )
                                "
                            />
                        </div>
                        <div class="px-2 col-12 pt-0">
                            <div
                                class="row p-0 m-0 py-1 justify-content-between align-items-center"
                            >
                                <InputColor
                                    v-model:pure-color="
                                        fillVar(i).colors.series[0]
                                    "
                                    style="width: 2rem; height: 2rem"
                                />

                                <input
                                    :id="'h_series' + i"
                                    maxlength="20"
                                    class="edit col-10 border-none text-bold"
                                    :placeholder="
                                        t(
                                            isProfile
                                                ? 'student-profile.series'
                                                : 'treinos.exercices.series',
                                        )
                                    "
                                    v-model="fillVar(i)['h_series']"
                                    style="
                                        flex: 1 !important;
                                        text-align: center;
                                    "
                                    :style="{
                                        backgroundColor:
                                            fillVar(i).colors.series[0],
                                        color: fillVar(i).colors.series[1],
                                    }"
                                />
                                <label
                                    :for="'h_series' + i"
                                    role="button"
                                    class="fa fa-edit"
                                ></label>

                                <InputColor
                                    v-model:pure-color="
                                        fillVar(i).colors.series[1]
                                    "
                                    style="width: 2rem; height: 2rem"
                                />
                            </div>
                            <input
                                type="text"
                                v-model="fillVar(i)['series']"
                                class="form-control"
                                required
                                :placeholder="
                                    t(
                                        isProfile
                                            ? 'student-profile.series'
                                            : 'treinos.exercices.series',
                                    )
                                "
                            />
                        </div>
                        <div class="px-2 col-12 pt-0">
                            <div
                                class="row p-0 m-0 py-1 justify-content-between align-items-center"
                            >
                                <InputColor
                                    v-model:pure-color="
                                        fillVar(i).colors.group[0]
                                    "
                                    style="width: 2rem; height: 2rem"
                                />

                                <input
                                    :id="'h_group' + i"
                                    maxlength="20"
                                    class="edit col-10 border-none text-bold"
                                    :placeholder="
                                        t(
                                            isProfile
                                                ? 'student-profile.group'
                                                : 'gifs.group',
                                        )
                                    "
                                    v-model="fillVar(i)['h_group']"
                                    style="
                                        flex: 1 !important;
                                        text-align: center;
                                    "
                                    :style="{
                                        backgroundColor:
                                            fillVar(i).colors.group[0],
                                        color: fillVar(i).colors.group[1],
                                    }"
                                />
                                <label
                                    :for="'h_group' + i"
                                    role="button"
                                    class="fa fa-edit"
                                ></label>

                                <InputColor
                                    v-model:pure-color="
                                        fillVar(i).colors.group[1]
                                    "
                                    style="width: 2rem; height: 2rem"
                                />
                            </div>
                            <input
                                type="text"
                                v-model="fillVar(i)['group']"
                                class="form-control"
                                required
                                :placeholder="
                                    t(
                                        isProfile
                                            ? 'student-profile.group'
                                            : 'gifs.group',
                                    )
                                "
                            />
                        </div>
                        <template v-if="isProfile">
                            <div class="px-2 col-12 pt-0">
                                <div
                                    class="row p-0 m-0 py-1 justify-content-between align-items-center"
                                >
                                    <InputColor
                                        v-model:pure-color="
                                            fillVar(i).colors.imc[0]
                                        "
                                        style="width: 2rem; height: 2rem"
                                    />

                                    <input
                                        :id="'h_imc' + i"
                                        maxlength="20"
                                        class="edit col-10 border-none text-bold"
                                        :placeholder="t('student-profile.imc')"
                                        v-model="fillVar(i)['h_imc']"
                                        style="
                                            flex: 1 !important;
                                            text-align: center;
                                        "
                                        :style="{
                                            backgroundColor:
                                                fillVar(i).colors.imc[0],
                                            color: fillVar(i).colors.imc[1],
                                        }"
                                    />
                                    <label
                                        :for="'h_imc' + i"
                                        role="button"
                                        class="fa fa-edit"
                                    ></label>

                                    <InputColor
                                        v-model:pure-color="
                                            fillVar(i).colors.imc[1]
                                        "
                                        style="width: 2rem; height: 2rem"
                                    />
                                </div>
                                <input
                                    type="text"
                                    v-model="fillVar(i)['imc']"
                                    class="form-control"
                                    required
                                    :placeholder="t('student-profile.imc')"
                                />
                            </div>
                            <div class="px-2 col-12 pt-0">
                                <div
                                    class="row p-0 m-0 py-1 justify-content-between align-items-center"
                                >
                                    <InputColor
                                        v-model:pure-color="
                                            fillVar(i).colors.magra[0]
                                        "
                                        style="width: 2rem; height: 2rem"
                                    />

                                    <input
                                        :id="'h_magra' + i"
                                        maxlength="20"
                                        class="edit col-10 border-none text-bold"
                                        :placeholder="
                                            t('student-profile.magra')
                                        "
                                        v-model="fillVar(i)['h_magra']"
                                        style="
                                            flex: 1 !important;
                                            text-align: center;
                                        "
                                        :style="{
                                            backgroundColor:
                                                fillVar(i).colors.magra[0],
                                            color: fillVar(i).colors.magra[1],
                                        }"
                                    />
                                    <label
                                        :for="'h_magra' + i"
                                        role="button"
                                        class="fa fa-edit"
                                    ></label>

                                    <InputColor
                                        v-model:pure-color="
                                            fillVar(i).colors.magra[1]
                                        "
                                        style="width: 2rem; height: 2rem"
                                    />
                                </div>
                                <input
                                    type="text"
                                    v-model="fillVar(i)['magra']"
                                    class="form-control"
                                    required
                                    :placeholder="t('student-profile.magra')"
                                />
                            </div>
                        </template>
                    </div>
                    <div
                        class="col-12 col-md-5 position-relative overflow-auto"
                        style="min-height: 4rem"
                    >
                        <template v-if="isProfile">
                            <div
                                style="
                                    display: flex;
                                    flex-direction: row;
                                    flex-wrap: nowrap;
                                    width: 100%;
                                    overflow-x: scroll;
                                "
                            >
                                <div
                                    v-for="(img, i) in images"
                                    :key="i"
                                    class="col-11 mx-1 position-relative d-flex justify-content-center"
                                    style="background: rgba(180, 180, 180, 0.5)"
                                >
                                    <button
                                        class="btn btn-danger position-absolute text-white top-0 left-0"
                                        type="button"
                                        @click="images.splice(i, 1)"
                                    >
                                        <i class="fa fa-trash"></i>
                                    </button>
                                    <img
                                        :src="createUrl(img)"
                                        style="
                                            max-height: 250px;
                                            max-width: 100%;
                                        "
                                    />
                                </div>
                            </div>
                            <div class="position-absolute bottom-0 right-0">
                                <span> {{ t("my-gifs.add") }} &emsp; </span>
                                <button
                                    v-if="images.length < 4"
                                    class="btn btn-warning text-white"
                                    type="button"
                                    @click="selectFile"
                                >
                                    <i class="fa fa-plus-circle"></i>
                                </button>
                            </div>
                        </template>
                        <template v-else>
                            <!-- <img class="image-responsive responsive col-12" style="min-height: 3rem" :src="imgs[i]"> -->
                            <img
                                v-if="!fillVar(i).usergif"
                                class="image-responsive responsive col-12"
                                style="min-height: 3rem"
                                :src="imgs[i]"
                            />
                            <img
                                v-else
                                class="image-responsive responsive col-12"
                                style="min-height: 3rem"
                                :src="imgs2[i]"
                            />
                            <button
                                class="btn btn-warning position-absolute text-white bottom-0 right-0"
                                type="button"
                                @click="() => openModal(i)"
                            >
                                <i class="fa fa-image"></i>
                            </button>
                        </template>
                    </div>
                    <div class="col-12">
                        <div class="col-12 p-2">
                            <div
                                class="row p-0 m-0 py-1 justify-content-between align-items-center"
                            >
                                <InputColor
                                    v-model:pure-color="
                                        fillVar(i).colors.description[0]
                                    "
                                    style="width: 2rem; height: 2rem"
                                />

                                <input
                                    :placeholder="t('treinos.description')"
                                    :id="'h_objectives' + i"
                                    maxlength="20"
                                    class="edit col-10 border-none text-bold"
                                    v-model="fillVar(i)['h_objectives']"
                                    style="
                                        flex: 1 !important;
                                        text-align: center;
                                    "
                                    :style="{
                                        backgroundColor:
                                            fillVar(i).colors.description[0],
                                        color: fillVar(i).colors.description[1],
                                    }"
                                />
                                <label
                                    :for="'h_objectives' + i"
                                    role="button"
                                    class="fa fa-edit"
                                ></label>

                                <InputColor
                                    v-model:pure-color="
                                        fillVar(i).colors.description[1]
                                    "
                                    style="width: 2rem; height: 2rem"
                                />
                            </div>
                            <textarea
                                class="form-control"
                                rows="5"
                                :name="'objetivos' + i"
                                v-model="fillVar(i)['objectives']"
                                maxlength="1500"
                            ></textarea>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="py-2 col-12 row justify-content-between">
                        <div class="col-auto">
                            <button class="btn btn-success mx-2" type="submit">
                                {{ t("treinos.create") }}
                            </button>
                            <button
                                class="btn btn-warning mx-2"
                                @click="back"
                                type="button"
                            >
                                <i class="fa fa-arrow-left mr-2"></i>
                                {{ t("general.back") }}
                            </button>
                        </div>

                        <div
                            v-if="this.user != null && !isProfile"
                            class="col-auto text-center"
                        >
                            <button
                                :disabled="
                                    Number(user.ai_credits) <
                                    (forms == 1
                                        ? aiPrices.normal
                                        : aiPrices.biset)
                                "
                                class="btn btn-primary"
                                type="button"
                                @click="showModalAi = true"
                            >
                                {{ t("ai.generate") }}
                            </button>
                            <br />
                            <span
                                >{{ t("ai.balance") }}: R$
                                {{ Number(user.ai_credits).toFixed(2) }}</span
                            >

                            <!-- <span class="small muted d-block">{{ t("ai.info") }}</span> -->
                        </div>
                    </div>
                </div>
            </form>
        </div>

        <modal-component
            @hide="showModal = false"
            :show="showModal"
            :classList="['col-12']"
            :title="t('gifs.select')"
        >
            <select-gif-component
                @selectGif="select"
                @selectPremium="selectPremium"
            ></select-gif-component>
        </modal-component>

        <modal-component
            @hide="selectAi = false"
            :show="selectAi"
            :classList="['col-12']"
            :title="t('gifs.select')"
        >
            <div class="row flex-wrap justify-content-evenly m-0 p-2 col-12">
                <template v-for="(path, i) in paths" :key="i">
                    <div
                        role="button"
                        class="p-2 file-container col-4 col-md-3 col-lg-2"
                        @click="
                            () => {
                                select(getNewGifUrl(path));
                            }
                        "
                    >
                        <v-lazy-image
                            :src="Api.url + 'images/GIFS/' + getNewGifUrl(path)"
                            class="col-12"
                        />
                        <!-- <div class="col-12 small p-0 m-0 text-center text-capitalize">{{name.toLowerCase().replace('gifs ', '').replace('.gif', '')}}</div> -->
                    </div>
                </template>
            </div>
        </modal-component>

        <modal-component
            v-if="!isProfile"
            @hide="showModalAi = false"
            :show="showModalAi"
            :classList="['col-12 col-md-6']"
            title="Gerar exercicio com i.a"
        >
            <div class="row justify-content-center p-4">
                <template v-if="this.user != null">
                    <textarea
                        :disabled="
                            Number(user.ai_credits) <
                            (forms == 1 ? aiPrices.normal : aiPrices.biset)
                        "
                        :placeholder="
                            t(forms == 1 ? 'ai.prompt' : 'ai.prompt2')
                        "
                        rows="7"
                        v-model="message"
                        class="form-control"
                    >
                    </textarea>
                    <div class="col-12">
                        <span
                            >{{
                                t("ai.cost").replace(
                                    "${0}",
                                    (forms == 1
                                        ? aiPrices.normal
                                        : aiPrices.biset
                                    )
                                        .toFixed(2)
                                        .replace(".", ","),
                                )
                            }}&emsp;</span
                        >
                        <strong
                            >R$
                            {{
                                Number(user.ai_credits)
                                    .toFixed(2)
                                    .replace(".", ",")
                            }}</strong
                        >
                    </div>

                    <br />
                    <button
                        :disabled="
                            Number(user.ai_credits) <
                            (forms == 1 ? aiPrices.normal : aiPrices.biset)
                        "
                        class="btn btn-primary btn-lg my-4"
                        @click="generate"
                    >
                        {{ t("ai.generate") }}
                    </button>
                </template>
            </div>
        </modal-component>
    </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import { t } from "@/lang";
import Api from "@/utilities/Api";
import ModalComponent from "@/components/AdminLTE/Components/ModalComponent.vue";
import SelectGifComponent from "../../components/SelectGifComponent.vue";
import InputColor from "@/components/InputColor.vue";
import VLazyImage from "v-lazy-image";

export default {
    name: "NewTreinoView",
    data() {
        return {
            Api,
            images: [],
            showModal: false,
            message: "",
            selectAi: false,
            showModalAi: false,
            paths: [],
            isProfile: false,
            aiPrices: {
                normal: 0.2,
                biset: 0.3,
            },
            treino: {
                title: "",

                duration: "",
                charge: "",
                series: "",
                group: "",
                objectives: "",
                imc: "",
                magra: "",
                usergif: 0,
                userGifUrl: null,

                h_duration: t("gifs.duration"),
                h_charge: t("gifs.charge"),
                h_series: t("treinos.exercices.series"),
                h_group: t("gifs.group"),
                h_objectives: t("treinos.description"),
                h_imc: t("student-profile.imc"),
                h_magra: t("student-profile.magra"),
                path: null,
                fitnes_id: null,
                child: null,

                colors: {
                    title: ["#808080", "#333333"],
                    duration: ["#d0d0d0", "#000000"],
                    charge: ["#d0d0d0", "#000000"],
                    series: ["#d0d0d0", "#000000"],
                    group: ["#d0d0d0", "#000000"],
                    imc: ["#d0d0d0", "#000000"],
                    magra: ["#d0d0d0", "#000000"],
                    description: ["#d0d0d0", "#000000"],
                },
            },
            selected: 1,
            forms: 0,
            user: null,
        };
    },
    components: {
        ModalComponent,
        SelectGifComponent,
        InputColor,
        VLazyImage,
    },
    async created() {
        document.title = t("gifs.new-ex");
        this.SET_LOADING(true);
        await Promise.all([this.getTreino(), this.getUser()]);
        this.SET_LOADING(false);
        console.log(this.forms);
    },
    computed: {
        ...mapState(["loading"]),
        imgs() {
            return {
                1: `${Api.url}images/GIFS/${this.treino.path}`,
                2: this.treino.child
                    ? `${Api.url}images/GIFS/${this.treino.child.path}`
                    : "",
            };
        },
        imgs2() {
            return {
                1: this.treino.userGifUrl,
                2: this.treino.child ? this.treino.child.userGifUrl : "",
            };
        },
    },
    methods: {
        ...mapActions(["get", "post", "put", "delete"]),
        ...mapMutations(["SET_LOADING"]),
        t,
        async generate() {
            if (!(this.message.trim().length > 0)) {
                return;
            }

            this.SET_LOADING(true);
            const response = await this.post({
                url: "ai/generate-fitnes",
                data: {
                    message: this.message,
                    biset: this.forms == 1 ? false : true,
                },
            });
            console.log(response);
            if (response.status == 200) {
                // alert("Selecione um gifs dos gerados pela IA")

                const fitnes = response.data.fitnes;
                Object.assign(this.treino, {
                    title: fitnes.title,
                    charge: fitnes.charge,
                    series: fitnes.series,
                    group: fitnes.group,
                    objectives: fitnes.description,
                    duration: fitnes.duration,
                    path: this.getNewGifUrl(fitnes.path),
                    h_charge: fitnes.h_charge,
                    h_group: fitnes.h_group,
                    h_series: fitnes.h_series,
                    h_description: fitnes.h_description,
                    h_duration: fitnes.h_duration,
                });

                if (fitnes.child) {
                    Object.assign(this.treino.child, {
                        charge: fitnes.charge,
                        series: fitnes.child.series,
                        group: fitnes.child.group,
                        objectives: fitnes.child.description,
                        duration: fitnes.child.duration,
                        path: this.getNewGifUrl(fitnes.child.path),
                        h_charge: fitnes.child.h_charge,
                        h_group: fitnes.child.h_group,
                        h_series: fitnes.child.h_series,
                        h_description: fitnes.child.h_description,
                        h_duration: fitnes.child.h_duration,
                    });
                }

                if (fitnes.paths.length > 0) {
                    this.paths = fitnes.paths;
                    this.selectAi = true;
                }

                this.message = "";
                // await this.getUser()
                this.user = response.data.user;
                this.showModalAi = false;
            } else {
                alert(response.data.message);
            }
            this.SET_LOADING(false);
        },
        async getUser() {
            // this.SET_LOADING(true)
            const response = await this.get({ url: "user" });
            console.log(response.data);
            if (response.status == 200) {
                this.user = response.data.user;
            } else {
                alert(response.data.message);
            }
            // this.SET_LOADING(false)
        },
        back() {
            this.$router.push("/fitnes/" + this.treino.fitnes_id);
        },
        createUrl(blob) {
            return URL.createObjectURL(blob);
        },
        selectFile() {
            this.$refs.file.click();
        },
        addImage(event) {
            if (this.images.length < 4) {
                if (event && event.target && event.target.files) {
                    const [file] = event.target.files;
                    if (file) {
                        this.images.push(file);
                    }
                }
            }
        },
        getNewGifUrl(url) {
            return url.replace("_new/", "__?path=");
            // return `__?path=${url}`
        },
        profile() {
            this.forms = 1;
            this.isProfile = true;
            this.treino.h_duration = t("student-profile.duration");
            this.treino.h_charge = t("student-profile.charge");
            this.treino.h_series = t("student-profile.series");
            this.treino.h_group = t("student-profile.group");
            this.treino.h_objectives = t("student-profile.description");
        },
        bisetType() {
            this.treino.child = {};
            this.treino.imc = "";
            this.treino.magra = "";
            for (let key in this.treino) {
                if (key != "child" && key != "colors") {
                    this.treino.child[key] = this.treino[key];
                }
            }
            this.treino.child.colors = {
                title: ["#808080", "#333333"],
                duration: ["#d0d0d0", "#000000"],
                charge: ["#d0d0d0", "#000000"],
                series: ["#d0d0d0", "#000000"],
                group: ["#d0d0d0", "#000000"],
                imc: ["#d0d0d0", "#000000"],
                magra: ["#d0d0d0", "#000000"],
                description: ["#d0d0d0", "#000000"],
            };
            this.forms = 2;
        },
        // select(path) {
        //     this.fillVar(this.selected).path = path
        //     this.showModal = false
        // },
        select(path, usergif = 0, name = undefined) {
            this.fillVar(this.selected).path = usergif ? name : path;
            this.fillVar(this.selected).usergif = usergif;
            this.fillVar(this.selected).userGifUrl = usergif ? path : null;
            this.showModal = false;
        },
        selectPremium(path, src) {
            console.log(src);
            this.fillVar(this.selected).path = path;
            this.fillVar(this.selected).usergif = 2;
            this.fillVar(this.selected).userGifUrl = src;
            this.showModal = false;
        },
        async getTreino() {
            // this.SET_LOADING(true)

            // const id = this.$route.params.id
            this.treino.fitnes_id = this.$route.params.id;
            const response = await this.get({
                url: "fitnesex/" + this.treino.fitnes_id,
            });

            if (response.status == 200) {
                const res2 = await this.get({ url: "plans/ai/fitnes" });
                console.log(res2);
                if (res2.status == 200) {
                    this.aiPrices.normal = res2.data.prices.normal;
                    this.aiPrices.biset = res2.data.prices.biset;
                }
            } else if (response.status == 401) {
                this.SET_USER(null);
                this.$router.push("/login");
            } else if (response.status == 404) {
                alert("Nao encontrado");
                this.$router.push("/fitnes");
            } else {
                alert(response.data.message);
            }
            // this.SET_LOADING(false)
        },
        openModal(i) {
            this.selected = i;
            this.showModal = true;
        },
        fillVar(i) {
            return i == 1 ? this.treino : this.treino.child;
        },
        async submit() {
            if (!this.isProfile) {
                if (
                    !this.treino.path ||
                    (this.treino.child && !this.treino.child.path)
                ) {
                    alert(t("gifs.select"));
                    return null;
                }
            }
            this.SET_LOADING(true);

            const fields = {
                path: "path",
                duration: "duration",
                charge: "charge",
                imc: "imc",
                series: "series",
                group: "group",
                description: "objectives",
                magra: "magra",
            };

            const frmDt = new FormData();
            frmDt.append("title", this.treino.title);

            for (let key in fields) {
                console.log(key);
                frmDt.append(key, this.treino[fields[key]]);
                frmDt.append(`h_${key}`, this.treino[`h_${fields[key]}`]);

                if (this.treino.child) {
                    frmDt.append(
                        `child[${key}]`,
                        this.treino.child[fields[key]],
                    );
                    frmDt.append(
                        `child[h_${key}]`,
                        this.treino.child[`h_${fields[key]}`],
                    );
                }
            }

            frmDt.delete("colors");
            frmDt.append("usergif", this.treino.usergif);
            if (this.treino.child) {
                frmDt.append("child[usergif]", this.treino.child.usergif);
            }
            Object.keys(this.treino.colors).forEach((key) => {
                frmDt.append(`colors[${key}][0]`, this.treino.colors[key][0]);
                frmDt.append(`colors[${key}][1]`, this.treino.colors[key][1]);
            });

            if (this.treino.child && this.treino.child.colors) {
                Object.keys(this.treino.child.colors).forEach((key) => {
                    frmDt.append(
                        `child[colors][${key}][0]`,
                        this.treino.child.colors[key][0],
                    );
                    frmDt.append(
                        `child[colors][${key}][1]`,
                        this.treino.child.colors[key][1],
                    );
                });
            }
            if (this.isProfile) {
                this.images.forEach((img, i) =>
                    frmDt.append(`images[${i}]`, img),
                );
            }

            frmDt.append("fitnes_id", this.treino.fitnes_id);

            const response = await this.post({
                url: "fitnesex",
                formData: frmDt,
                data: frmDt,
            });
            console.log(response);
            if (response.status == 200) {
                alert(t("gifs.created"));
                this.$router.push("/fitnes/" + this.treino.fitnes_id);
            } else {
                alert(response.data.message);
            }
            console.log(response);
            this.SET_LOADING(false);
        },
    },
};
</script>

<style scoped lang="scss">
.file-container {
    transition: all 0.3s ease-in-out;
    border-radius: 7px;
    &:hover {
        transform: scale(1.05);
        // background: rgba(200, 200, 200, 0.7);
    }

    .img {
        aspect-ratio: 1 / 1; /* Define a proporção 1:1 (quadrado) */
        object-fit: contain;
    }
}

.pages {
    border: 1px solid gray;

    .paginate {
        width: 2rem !important;
        height: 2rem !important;
        font-weight: bold;
        text-align: center;
        vertical-align: middle;
    }
}
</style>
